import { freeze, assign, assoc, getIn } from 'icepick';
import type { Component } from '../../common/model/types.tsx';
import {
	SET_COMPONENTS_PAGE,
	PATCH_COMPONENT,
	type PatchComponentAction,
	type SetComponentsPageAction,
} from '../actions.tsx';

export type ComponentsState = {
	byId: {
		[key: string]: Component;
	};
	list: string[];
	listAri: string[];
	totalItems: number;
};

export const initialState: ComponentsState = freeze({
	byId: {},
	list: [],
	listAri: [],
	totalItems: 0,
});

type Action = SetComponentsPageAction | PatchComponentAction;

const components = (state: ComponentsState = initialState, action: Action): ComponentsState => {
	switch (action.type) {
		case SET_COMPONENTS_PAGE: {
			return assign(state, {
				byId: action.payload.byId,
				list: action.payload.list,
				listAri: action.payload.listAri,
				totalItems: action.payload.total,
			});
		}

		case PATCH_COMPONENT: {
			const componentId = action.payload.id;
			const originalComponent = getIn(state.byId, [componentId]);
			const patchedComponent = assign({}, originalComponent, action.payload.component);
			return freeze({
				...state,
				byId: assoc(state.byId, componentId, patchedComponent),
			});
		}

		default:
			return state;
	}
};

export default components;
